import { Button } from "@mui/material"
import noop from "lib/noop"

/**
 * A styled Mui button with theme info colors, useful for in info severity alerts.
 *
 * @param {string} text - The text printed inside the button.
 * @param {function} onClick - The function to run when the button is clicked.
 * @returns A pre styled Mui Button.
 */
export function InfoButton({ text, onClick = noop, sx, ...props }) {
    return (
        <Button
            sx={{
                color: "info.darker",
                borderColor: "info.darker",
                "&:hover": {
                    borderColor: "info.darker",
                    backgroundColor: "#0A3A6614",
                },
                ...sx,
            }}
            variant="outlined"
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}
